
import styles from './ua.module.scss'

export default function KeyValue(props) {
  
  return <div className={styles.container}>
    <label>{ props.label }</label>
    { props.value &&
    <span>{ props.value }</span>
    }
    { props.children }
  </div>
  
}